/*
 * @Author: lyodon.li lyodon.li@feisu.com
 * @Date: 2025-03-04 14:24:31
 * @LastEditors: lyodon.li lyodon.li@feisu.com
 * @LastEditTime: 2025-12-03 15:05:06
 * @FilePath: /designcenter/src/utils/modules/request.ts
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import axios from 'axios'
import { Base64 } from 'js-base64'
import CryptoJS from 'crypto-js'
import { useWebsiteInfoStore } from '@/store/websiteInfo'
import { Cookie, handleFsLink, parseUrlParams, setLoginUrl } from '@/utils'

// import { useUserStore } from '@/store/user'
import { FsMessage } from 'fs-design'

// import { message } from 'ant-design-vue'

import type { AxiosInstance, AxiosRequestConfig, AxiosResponse } from 'axios'
import type { IRes } from '@/types'

const genNonce = (num: number) => {
  const chars = '0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz'
  let str = ''
  for (let i = 0; i < num; i++) {
    const pos = Math.round(Math.random() * (chars.length - 1))
    str += chars[pos]
  }
  return str
}
const request: AxiosInstance = axios.create({
  baseURL: import.meta.env.VITE_API_BASE_URL,
  timeout: 50000,
})

request.interceptors.request.use(
  config => {
    const websiteInfoStore = useWebsiteInfoStore()
    const timestamps = new Date().getTime()
    const nonce = genNonce(16)
    // 从环境变量读取 API Key 和 HMAC Secret，避免硬编码
    const apiKey = import.meta.env.VITE_API_KEY || 'yuxuanxuanpc'
    const hmacSecret = import.meta.env.VITE_HMAC_SECRET || 'yuxuan3507'
    const payload = '[]'
    const s = timestamps + nonce + payload
    const h = CryptoJS.algo.HMAC.create(CryptoJS.algo.SHA256, hmacSecret)
    h.update(s)
    const signature = Base64.encode(CryptoJS.enc.Hex.stringify(h.finalize()))
    const urlParams = parseUrlParams()
    config.headers.timestamps = timestamps
    config.headers.nonce = nonce
    config.headers.apiKey = apiKey
    config.headers.clientSignature = signature
    const token =
      Cookie.get('token_new') ||
      urlParams.token ||
      location.search.split('token=')[1] ||
      localStorage.getItem('token_new') ||
      ''
    console.log(token, 'token-----')
    const fs_websiteinfo = JSON.parse(JSON.stringify(websiteInfoStore.$state))
    // console.log('wrw43423422')

    if (fs_websiteinfo) {
      config.headers['websiteinfo'] = Base64.encode(JSON.stringify(fs_websiteinfo))
    }
    if (token) {
      config.headers['authorization'] = token
    }
    return config
  },
  error => {
    return Promise.reject(error)
  }
)

request.interceptors.response.use(
  async (response: AxiosResponse) => {
    if (response.config.responseType === 'blob') {
      const blob = response.data
      
      // 检查 Content-Type，如果是 PDF 或其他二进制文件，直接返回
      const contentType = response.headers['content-type'] || ''
      console.log('[Request] Blob响应 - Content-Type:', contentType, '文件大小:', blob.size, 'bytes')
      
      if (contentType.includes('application/pdf') || 
          contentType.includes('application/octet-stream') ||
          contentType.includes('image/')) {
        // 直接返回 blob 数据
        console.log('[Request] 返回二进制文件，大小:', (blob.size / 1024 / 1024).toFixed(2), 'MB')
        return blob
      }
      
      // 如果是其他类型，尝试解析为 JSON（可能是错误信息）
      try {
        const text = await blob.text()
        const json = JSON.parse(text)
        console.log('[Request] Blob响应实际是JSON错误:', json)
        // 如果能成功 parse，则说明其实是错误信息
        if (json.message) {
          FsMessage({
            type: 'danger',
            message: json.message,
          })
        }

        return Promise.reject(json)
      } catch (e) {
        // 解析失败，说明真的是文件，正常返回
        console.log('[Request] Blob解析失败，返回原始blob')
        return blob
      }
    }

    const res = response.data as unknown as IRes
    if (res.code >= 400) {
      //  && import.meta.env.PROD
      if (res.code === 401) {
        // userStore.logout()
        location.href = handleFsLink(`/login.html?redirect=${setLoginUrl()}`)
      } else {
        if (res.message && res.code !== 40001 && res.code !== 40004) {
          FsMessage({
            type: 'danger',
            message: res.message,
          })
        }
      }
      return Promise.reject(res)
    }
    return response.data
  },
  error => {
    console.log('[Request] 响应错误:', error)
    console.log('[Request] 错误代码:', error.code)
    console.log('[Request] 错误消息:', error.message)
    
    const res = (error.response?.data as unknown as IRes) || { msg: error.message || '' }
    
    // 处理超时错误
    if (error.code === 'ECONNABORTED' || error.message?.includes('timeout')) {
      console.error('[Request] 请求超时')
      FsMessage({
        type: 'danger',
        message: '请求超时，请稍后重试',
      })
      return Promise.reject({ 
        code: 'TIMEOUT', 
        message: '请求超时，请稍后重试',
        originalError: error 
      })
    }
    
    // 处理网络错误
    if (error.message === 'Network Error') {
      console.error('[Request] 网络错误')
      FsMessage({
        type: 'danger',
        message: '网络连接失败，请检查网络',
      })
      return Promise.reject({ 
        code: 'NETWORK_ERROR', 
        message: '网络连接失败',
        originalError: error 
      })
    }
    
    // 处理401未授权
    if (error.status === 401 || error.response?.status === 401) {
      location.href = handleFsLink(`/login.html?redirect=${setLoginUrl()}`)
      return Promise.reject(res)
    }
    
    // 其他错误
    if (res.message) {
      FsMessage({
        type: 'danger',
        message: res.message,
      })
    }
    
    return Promise.reject(res)
  }
)

class ApiRequest {
  private static instance: ApiRequest
  constructor(private request: AxiosInstance) {}

  public static getInstance(request: AxiosInstance): ApiRequest {
    if (!this.instance) this.instance = new ApiRequest(request)
    return this.instance
  }

  get<T>(url: string, config?: AxiosRequestConfig) {
    return this.request.get<T>(url, config) as unknown as Promise<T>
  }

  post<T>(url: string, data?: unknown, config?: AxiosRequestConfig) {
    return this.request.post<T>(url, data, config) as unknown as Promise<T>
  }

  put<T>(url: string, data?: unknown, config?: AxiosRequestConfig) {
    return this.request.put<T>(url, data, config) as unknown as Promise<T>
  }

  patch<T>(url: string, data?: unknown, config?: AxiosRequestConfig) {
    return this.request.patch<T>(url, data, config) as unknown as Promise<T>
  }

  delete<T>(url: string, config?: AxiosRequestConfig) {
    return this.request.delete<T>(url, config) as unknown as Promise<T>
  }
}

function getApiRequest() {
  return ApiRequest.getInstance(request)
}

export { request, getApiRequest }
